const STORAGE_KEY = "ucasal_form_state";

export const saveFormState = (state) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (e) {
    console.error("Error saving form state", e);
  }
};

export const loadFormState = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    console.error("Error loading form state", e);
    return null;
  }
};

export const clearFormState = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.error("Error clearing form state", e);
  }
};

    